// Automatically generated
var FORM_STATE_KEYS = ["baseId", "unstable_idCountRef", "values", "touched", "messages", "errors", "validating", "valid", "submitting", "submitSucceed", "submitFailed", "setBaseId", "reset", "validate", "submit", "update", "blur", "push", "remove"];
var FORM_KEYS = FORM_STATE_KEYS;
var FORM_CHECKBOX_KEYS = [].concat(FORM_KEYS, ["name", "value"]);
var FORM_GROUP_KEYS = [].concat(FORM_KEYS, ["name"]);
var FORM_INPUT_KEYS = FORM_GROUP_KEYS;
var FORM_LABEL_KEYS = [].concat(FORM_INPUT_KEYS, ["label"]);
var FORM_MESSAGE_KEYS = FORM_INPUT_KEYS;
var FORM_PUSH_BUTTON_KEYS = [].concat(FORM_MESSAGE_KEYS, FORM_CHECKBOX_KEYS);
var FORM_RADIO_KEYS = FORM_PUSH_BUTTON_KEYS;
var FORM_RADIO_GROUP_KEYS = FORM_MESSAGE_KEYS;
var FORM_REMOVE_BUTTON_KEYS = [].concat(FORM_RADIO_GROUP_KEYS, ["index"]);
var FORM_SUBMIT_BUTTON_KEYS = FORM_KEYS;

export { FORM_KEYS as F, FORM_CHECKBOX_KEYS as a, FORM_GROUP_KEYS as b, FORM_INPUT_KEYS as c, FORM_LABEL_KEYS as d, FORM_MESSAGE_KEYS as e, FORM_PUSH_BUTTON_KEYS as f, FORM_RADIO_KEYS as g, FORM_RADIO_GROUP_KEYS as h, FORM_REMOVE_BUTTON_KEYS as i, FORM_SUBMIT_BUTTON_KEYS as j };
